import Vue from 'vue';
import VueGtm from 'vue-gtm';
import VueAnalytics from "vue-analytics";
import { gtag, install } from 'ga-gtag';
import VueRouter from 'vue-router';
import VueSocketIO from 'vue-socket.io';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import Repository from "./repositories/Repository";
import AuthRepository from "./repositories/AuthRepository";
import ApiRepository from "./repositories/ApiRepository";
import LocalRepository from "./repositories/LocalRepository";
import i18n from '@/locales/i18n';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader

// Views
import Admin from '@/views/Admin.vue';
import Create from '@/views/Create.vue';
import Clients from '@/views/Clients.vue';
import Login from '@/views/Login.vue';
import Invoice from '@/views/Invoice.vue';
import Help from "./views/Help";
import Profile from "./views/Profile";
import Register from "./views/Register";
import Browse from './views/BrowseScroll';
import Main from "./views/MainView";
import SpecificCompensation from "./views/SpecificCompensation";
import imageInvoice from "./components/ImageInvoice";
import ComparativeInvoice from "./components/ComparativeInvoice";
import ComparativeInvoiceDownload from "./components/ComparativeInvoiceDownload";
import Certificate from "./components/Certificate";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Bypay from "./views/Bypay";
import Forward from "./views/Forward";
import CookiePolicy from "./views/CookiePolicy";
import LandingPage from "./views/LandingPage";
import LandingAC from "./views/LandingAC";
import MoreInfo from "./views/MoreInfo";
import CompensationSteper from "./views/CompensationSteper";
import Notifications from "./views/Notifications";
import MarketPlace from "./views/Marketplace";
import AcceptBypayes from "./views/acceptBypayes";
import AMM from "./views/AMM";
import Exchange from "./views/Exchange";
import InvoiceChats from "./views/InvoiceChats";
import Chat from "./views/Chat";

// Layouts
import EmptyLayout from "@/layouts/EmptyLayout";
import MainLayout from "@/layouts/MainLayout";
import LoginLayout from "@/layouts/LoginLayout";
import RegisterLayout from "@/layouts/RegisterLayout";
import LandingLayout from "@/layouts/LandingLayout";
const LAYOUT_PATH = "/";

Vue.use(VueRouter);

import VueAxios from 'vue-axios';
import VueAuthenticate from 'vue-authenticate';
import axios from 'axios';
import AllFilesChat from "./components/AllFilesChat";
import AllInvoicesChat from "./components/AllInvoicesChat";
import Faucet from "./views/Faucet.vue";
import InvoiceChatsArchived from "@/views/InvoiceChatsArchived";
import Settings from "@/views/Settings.vue";
import Tutorial from "@/views/Tutorial.vue";


Vue.use(VueAxios, axios);
Vue.use(VueAuthenticate, {
    baseUrl: 'http://localhost:8080', // Your API domain
    providers: {
        /*linkedin: {
            clientId: '78kbsaahkaez0w',
            clientSecret: "Dg8RDfwsvI9kIcVo",
            redirectUri: 'http://localhost:8080/login'
        }*/
        linkedin: {
            clientId: '78kbsaahkaez0w',
            clientSecret: "Dg8RDfwsvI9kIcVo",
            grant_type: 'authoritzation_code',
            scope: 'r_emailaddress',
            redirectUri: 'http://localhost:8080/login'
        }

    }
});

// Global Data
const globalData = new Vue({ data: { $user: null, $parameters: null } });
Vue.mixin({
    computed: {
        $user: {
            get: function () { return globalData.$data.$user; },
            set: function (newUser) { globalData.$data.$user = newUser; }
        },
        $parameters: {
            get: function () { return globalData.$data.$parameters; },
            set: function (value) { globalData.$data.$parameters = value; }
        }
    }
});
ApiRepository.getParameters().then((res) => {
    if (res && res.data && res.data.params) {
        globalData.$data.$parameters = res.data.params;
    }
}).catch((err) => {
    console.log(err);
});

Vue.use(new VueSocketIO({debug: false, connection: '/', options: {path: Repository.getSocketPath()}}));

const routes = [
    {
    /**
     * Public Zone
     */
        path: LAYOUT_PATH,
        component: MainLayout,
        children: [
            { path: '/', name: 'root', beforeEnter: (to, from, next) => {
                console.log(globalData.$data.$user);
                if (globalData.$data.$user) {
                    next({name: 'InvoiceChats', replace: true});
                }
                else {
                    next({name: 'LandingPage', replace: true});
                }
            }
            },
            {
                path: LAYOUT_PATH,
                component: EmptyLayout,
                children: [
                    { path: '/admin', name: 'Admin', component: Admin },
                    { path: '/profile', name: 'profile', component: Profile },
                    { path: '/invoice/:id', name: 'invoice', component: Invoice },
                    { path: '/specific-compensation', name: 'SpecificCompensation', component: SpecificCompensation },
                    { path: '/privacyPolicy', name: 'PrivacyPolicy', component: PrivacyPolicy},
                    { path: '/cookiePolicy', name: 'CookiePolicy', component: CookiePolicy},
                    { path: '/viewInvoice', name: 'viewInvoice', component: Browse },
                    { path: '/compensationSteper', name: 'CompensationSteper', component: CompensationSteper },
                    { path: '/acceptBypayes', name: 'AcceptBypayes', component: AcceptBypayes },
                    { path: '/notifications', name: 'Notifications', component: Notifications },
                    { path: '/marketplace', name: 'MarketPlace', component: MarketPlace },
                    // { path: '/navigationMenu', name: 'NavigationMenu', component: MenuView },
                    { path: '/exchange', name: 'Exchange', component: Exchange },
                    { path: '/AMM', name: 'AMM', component: AMM },
                    { path: '/InvoiceChats', name: 'InvoiceChats', component: InvoiceChats },
                    { path: '/InvoiceChatsArchived', name: 'InvoiceChatsArchived', component: InvoiceChatsArchived },
                    { path: '/Chat', name: 'Chat', component: Chat},
                    { path: '/AllFilesChat', name: 'AllFilesChat', component: AllFilesChat},
                    { path: '/AllInvoicesChat', name: 'AllInvoicesChat', component: AllInvoicesChat},
                    { path: '/faucet', name: 'Faucet', component: Faucet},
                    { path: '/Settings', name: 'Settings', component: Settings},
                    { path: '/Tutorial', name: 'Tutorial', component: Tutorial}

                ]
            },
        ]
    }, {
        /**
         * IDK Zone
         */
        path: LAYOUT_PATH,
        component: LoginLayout,
        children: [
            {
                path: LAYOUT_PATH,
                component: EmptyLayout,
                children: [
                    { path: '/login', name: 'Login', component: Login },
                ]
            }

        ]
    }, {
        /**
         * IDK Zone
         */
        path: LAYOUT_PATH,
        component: LandingLayout,
        children: [
            {
                path: LAYOUT_PATH,
                component: EmptyLayout,
                children: [
                    { path: '/landingPage', name: 'LandingPage', component: LandingLayout},
                    /*{ path: '/moreInfo', name: 'MoreInfo', component: MoreInfo},
                    { path: '/LandingAC', name: 'LandingAC', component: LandingAC},*/
                    // { path: '/navigationMenu', name: 'Logout', component: MenuView },
                ]
            }

        ]
    }, {
        /**
         * IDK Zone
         */
        path: LAYOUT_PATH,
        component: RegisterLayout,
        children: [
            {
                path: LAYOUT_PATH,
                component: EmptyLayout,
                children: [
                    { path: '/register', name: 'Register', component: Register },
                ]
            }
        ]
    }, {
        /**
         * Authorized Zone
         */
        path: LAYOUT_PATH,
        component: MainLayout,
        meta: {
            auth: true,
        },
        children: [
            {
                path: LAYOUT_PATH,
                component: EmptyLayout,
                children: [
                    { path: '/main', name: 'home', component: Main },
                    { path: '/faq', name: 'faq', component: Help},
                    { path: '/invoices', name: 'invoices', component: Create },
                    { path: '/clients', name: 'clients', component: Clients },
                    { path: '/photo-invoice', name: 'imageInvoice', component: imageInvoice },
                    { path: '/bypay', name: 'Bypay', component: Bypay },
                    { path: '/forward', name: 'Forward', component: Forward },
                    { path: '/comparative-invoice', name: 'ComparativeInvoice', component: ComparativeInvoice },
                    { path: '/comparative-invoice-download', name: 'ComparativeInvoiceDownload', component: ComparativeInvoiceDownload },
                    { path: '/certificate', name: 'Certificate', component: Certificate },
                    // { path: '/marketplace', name: 'MarketPlace', component: MarketPlace },
                    // { path: '/navigationMenu', name: 'NavigationMenu', component: MenuView },
                ]
            }
        ]
    },
];

const router = new VueRouter({routes,  mode: 'history'});

try {
    // eslint-disable-next-line global-require
    require('../../Server/config/config.local'); //És per saber si s'ha d'usar el google analytics o no
} catch (ignored) {
    install('G-RN5DSQD9N4');
}


const navigate = (next, options = {}) => {
    next(options);
    window.scrollTo(0, 0);
};

// Handle before each route
router.beforeEach((to, from, next) => {

    // If no matches go to home
    if (!to || to.matched.length === 0) {
        return navigate(next, {name: "root", replace: true});
    }

    // Check for the meta tags
    let auth = null;
    for (const match of to.matched) {
        if (match.meta.hasOwnProperty("auth")) {
            auth = match.meta.auth;
        }
    }
    // Get the user from server
    AuthRepository.getMe()
        .then(user => {
            if (user) {
                // We are logged in
                globalData.$data.$user = user;
            } else {
                // We are not logged in
                globalData.$data.$user = null;
                LocalRepository.clear("token");
                if (auth) {
                    // Go to login
                    return navigate(next, {name: 'Login', params: {next: {path: to.path}}, replace: true});
                }
            }
            // All ok, proceed
            navigate(next);

        }).finally(() => {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register('/service-worker.js')
                    .then((reg) => {
                        /*console.log("Yes, it did.");
                        console.log('ServiceWorker registration successful with scope: ', reg.scope);*/
                        navigator.serviceWorker.ready.then(reg => {
                            const urlB64ToUint8Array = base64String => {
                                const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
                                const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
                                const rawData = atob(base64);
                                const outputArray = new Uint8Array(rawData.length);
                                for (let i = 0; i < rawData.length; ++i) {
                                    outputArray[i] = rawData.charCodeAt(i);
                                }
                                return outputArray;
                            };
                            reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8Array("BDq1HMRI9tL2xGMunv11V27KpR6Np53MUKheDxPz8Nz2EBaRO59EtbMJWd7WaAk0smnnmTBptM9kMHFulO2Gdj0") })
                                .then((subscription) => {
                                    if (globalData.$data.$user)
                                        AuthRepository.saveSubscription(JSON.stringify(subscription));
                                }).catch((err) => {
                                    console.log('Failed to subscribe the user: ', err);
                                });
                        });
                    }).catch((err) => {
                        console.log("No it didn't. This happened: ", err);
                    });
            }
        });
});

new Vue({
    router,
    vuetify,
    i18n: i18n.data,
    render: h => h(App)
}).$mount('#app');
